import { useEffect, useState } from "react"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { _AdquisitionContract } from "../../../core/services/dataBean/EntityCatalog"
import { toast } from "react-toastify"
import { AccountEditor } from "../../editor/AccountEditor"
import { BasicTable, MASK_MONEY } from "../../theme/Component/BasicTable"

interface Props {
    idAccount: number;
    onChange: Function;
    idContract?: number;
}

export const EditorContractByIDAccount = ({ idAccount, onChange, idContract }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_AdquisitionContract)
    const [idAcc, setIDAcc] = useState<number>(idAccount ?? NaN)

    useEffect(() => {
        if (idAcc) {
            getLista()
        }
    }, [idAcc])

    useEffect(() => {
        if (idContract) {
            getContract()
        }
    }, [idContract])

    const getContract = () => {
        instance.getAdquisitionContract(idContract).then(
            (resp) => {
                console.log(resp)
                onChange(resp)
            }
        ).catch(err => { console.log(err) })
    }

    const getLista = () => {
        const props = {
            IDAccount: idAcc,
            State: 1
        }
        instance.getAdquisitionContractRender(null, null, props, null, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("No se pudo obtener la información")
            }
        )
    }

    useEffect(() => {
        onChange(bean)
    }, [bean])

    const head = [
        { title: 'ID', property: 'IDAdquisitionContract', visible: false },
        { title: 'Valor Contrato', property: 'ContractValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor CDP', property: 'CDPValue', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Contrato', property: 'SeleccionDate', visible: true },
        { title: 'Dodo radicado', property: 'Code', visible: false },
        { title: 'Código contrato', property: 'InternalCode', visible: true },
        { title: 'Proveedor', property: 'Name1', visible: false },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'No CDP', property: 'NoCDP', visible: false },
        { title: 'Fecha CDP', property: 'DateCDP', visible: false },
        { title: 'No registro presupuestal', property: 'NoRegistroPresupuestal', visible: false },
        { title: 'Fecha registro presupuestal', property: 'DateRegPresupuestal', visible: false },
    ]


    return (
        <div className="row">
            {!idAcc &&
                <div className="col-md-12">
                    <AccountEditor idAccount={idAcc} label="Beneficiario" onChange={(e) => { setIDAcc(e.IDAccount) }} />
                </div>
            }
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} />
            </div>
        </div>
    )
}